module.exports = __webpack_public_path__ + "static/img/pictureC.139cd526.png";